import React, { useEffect, useState } from 'react';

const CA_third_comp = () => {
  const [set, setSet] = useState(0);
  const [full, setFull] = useState(false);
  const targetY = window.innerHeight * 0.8;

  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    const timeline = document.querySelector('.timeline');
    const line = document.querySelector('.line');

    function scrollHandler() {
      const scrollY = window.scrollY;
      const up = scrollY < prevScrollY;
      const down = !up;

      const timelineRect = timeline.getBoundingClientRect();
      const lineRect = line.getBoundingClientRect();

      const dist = targetY - timelineRect.top;

      if (down && !full) {
        setSet(Math.max(set, dist));
        line.style.bottom = `calc(100% - ${set}px)`;
      }

      if (dist > timeline.offsetHeight + 50 && !full) {
        setFull(true);
        line.style.bottom = `-50px`;
      }

      sections.forEach((item) => {
        const rect = item.getBoundingClientRect();

        if (rect.top + item.offsetHeight / 5 < targetY) {
          item.classList.add('show-me');
        }
      });

      prevScrollY = window.scrollY;
    }

    let prevScrollY = window.scrollY;
    scrollHandler();
    line.style.display = 'block';
    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, [set, full]);

  return (
    <div className=''>
      <div className="">
        <div className="top-section">
          <h2 className='Roadmap_text display-6 pb-1'>Start your Campus Ambassador Journey</h2>
        </div>
        <div className="timeline mt-5">
          <div className="line"></div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content">
              <h6 className='text-bold fs-4'>Personal Growth:</h6>
              <p>Ambassadors often undergo personal development training or workshops, fostering growth in areas such as public speaking, time management, and interpersonal skills, which are beneficial beyond the role itself.
              </p>
            </div>
          </div>

          <div className="section d-flex justify-content-end">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content">
              <h6 className='text-bold fs-4'>Creative Expression:</h6>
              <p>Some ambassador programs encourage creativity, allowing you to express yourself through innovative campaigns, events, or content creation, providing a platform to showcase your ideas and talents.</p>
            </div>
          </div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content">
              <h6 className='text-bold fs-4'>Visibility and Influence:</h6>
              <p>As an ambassador, you may have the opportunity to become a voice for your peers, influencing decisions, policies, or initiatives within the university or organization.</p>
            </div>
          </div>

          <div className="section d-flex justify-content-end">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content">
              <h6 className='text-bold fs-4'>Access to Internships or Job Opportunities:</h6>
              <p>Some ambassador programs have partnerships with companies or organizations, providing exclusive access to internships, job opportunities, or recruitment events, giving you a head start in your career.</p>
            </div>
          </div>

          <div className="section">
            <div className="Road_map_bead"></div>
            <div className="Road_map_content">
              <h6 className='text-bold fs-4'>Certificate of Recognition/ Financial Compensation (Stipend):</h6>
              <p>As a campus ambassador, you can receive a Certificate of Recognition, an official acknowledgment highlighting your commitment and acquired skills, valuable for future opportunities. Additionally, some programs offer Financial Compensation (Stipend), providing monetary support for your efforts, assisting with personal expenses, or serving as supplemental income during your ambassadorship.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CA_third_comp;